import { AppCountry } from '@/constants/app.constant'
import { transformDefault } from '@/utils/transform.util'
import * as ISchemaStore from './data.d'
import * as transformStore from './transform'
import { transformFetchReportListID } from './transform.id.vm'

function getConfigFetchStoreListID() {
  return {
    service: (payload: ISchemaStore.IStoreListRequest) => ({
      url: '/api/seller/stores',
      method: 'POST',
      data: payload,
    }),
    formatResult: transformDefault,
  }
}

function getConfigFetchStoreListVN() {
  return {
    service: (payload: ISchemaStore.IStoreListRequest) => ({
      url: '/api/v5/seller/store/get_basic_infos_for_partner_web',
      method: 'POST',
      data: transformStore.transformStoreListRequest(payload),
    }),
    formatResult: transformStore.transformStoreListResponse,
  }
}

export function getConfigFetchStoreList() {
  const getRequestConfig = AppCountry.isVn ? getConfigFetchStoreListVN : getConfigFetchStoreListID

  return getRequestConfig()
}

function getConfigSearchStoreListID() {
  return {
    service: (payload: ISchemaStore.ISearchStoreListRequest) => ({
      url: '/api/seller/stores/search',
      method: 'POST',
      data: payload,
    }),
    formatResult: transformDefault,
  }
}

export function getConfigSearchStoreList() {
  const getRequestConfig = getConfigSearchStoreListID

  return getRequestConfig()
}

function getConfigFetchStoreDetailID() {
  return {
    service: () => ({
      url: '/api/seller/store',
      method: 'GET',
    }),
    formatResult: transformDefault,
  }
}

function getConfigFetchStoreDetailVN() {
  return {
    service: () => [
      {
        method: 'GET',
        url: '/api/v5/seller/store/get_basic_info',
      },
      {
        method: 'POST',
        url: '/api/v5/seller/store/settings-page/get',
      },
      {
        method: 'GET',
        url: '/api/v5/seller/store/opening-status/refact/get',
      },
    ],
    formatResult: transformStore.transformStoreDetailResponse,
  }
}

export function getConfigFetchStoreDetail() {
  const getRequestConfig = AppCountry.isVn
    ? getConfigFetchStoreDetailVN
    : getConfigFetchStoreDetailID

  return getRequestConfig()
}

function getFetchStoreBranchListConfigID() {
  return {
    service: () => Promise.resolve({ code: 0, msg: '', data: { branches: [] } }),
    formatResult: transformDefault,
  }
}

function getFetchStoreBranchListConfigVN() {
  return {
    service: () => ({
      method: 'GET',
      url: '/api/v5/seller/store/branches',
    }),
    formatResult: transformDefault,
  }
}

export function getFetchStoreBranchListConfig() {
  const getRequestConfig = AppCountry.isVn
    ? getFetchStoreBranchListConfigVN
    : getFetchStoreBranchListConfigID

  return getRequestConfig()
}

function getConfigUpdateOpeningStatusOpenID() {
  return {
    service: (payload: ISchemaStore.UpdateOpeningStatusOpenRequest) => ({
      url: '/api/seller/store/opening-status/action/open',
      method: 'POST',
      data: payload,
    }),
    formatResult: transformDefault,
  }
}

export function getConfigUpdateOpeningStatusOpen() {
  const getRequestConfig = getConfigUpdateOpeningStatusOpenID

  return getRequestConfig()
}

function getConfigUpdateOpeningStatusPauseID() {
  return {
    service: (payload: ISchemaStore.UpdateOpeningStatusPauseRequest) => ({
      url: '/api/seller/store/opening-status/action/pause',
      method: 'POST',
      data: payload,
    }),
    formatResult: transformDefault,
  }
}

export function getConfigUpdateOpeningStatusPause() {
  const getRequestConfig = getConfigUpdateOpeningStatusPauseID

  return getRequestConfig()
}

// #region 导出报告相关

/**
 * ID
 * 提交导出请求
 */
function getConfigSubmitExportID() {
  return {
    service: (params: ISchemaStore.IReportSubmitParams) => ({
      url: '/api/seller/store/export-task/submit',
      method: 'POST',
      data: params,
    }),
    formatResult: transformDefault,
  }
}

export function getConfigSubmitExport() {
  const getServiceConfig = getConfigSubmitExportID

  return getServiceConfig()
}

/**
 * ID
 * 查询导出报告列表
 */
function getConfigFetchReportListID() {
  return {
    service: (params: ISchemaStore.IReportListParams) => ({
      url: '/api/seller/store/export-task/list',
      method: 'GET',
      params: {
        ...params,
      },
    }),
    formatResult: transformFetchReportListID,
  }
}

export function getConfigFetchReportList() {
  const getServiceConfig = getConfigFetchReportListID

  return getServiceConfig()
}

//  #endregion 导出报告相关
